export default __webpack_public_path__ + "static/national-2-extrabold-59aa7e21ca70e460a12ffd0d659cecea.woff2";